import React from 'react';
import { useTranslation } from 'react-i18next';

import { SCHEDULE_SECTION } from 'pages/create-activity/constants';

import Typography from '@material-ui/core/Typography';

import {
  PricesDaily,
  PricesEqual,
  PricesDailySchedule,
  DailyPricesFixed,
  PricesFixed
} from 'components';

import { useStyles } from './styles';

const PricesCreate = ({
  isOpen,
  selectedTabIndex,
  scheduleTabIndex,
  onSubmit,
  setSubmitButton,
  isUpdate
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const DAILY_PRICES = {
    firstSection: 0,
    secondSection: 1,
    thirdSection: 2
  };

  if (isOpen) {
    selectedTabIndex++;
  }

  if (scheduleTabIndex === SCHEDULE_SECTION.dateNoTime) {
    return (
      <div className={classes.wrapper}>
        {selectedTabIndex === DAILY_PRICES.firstSection && (
          <DailyPricesFixed
            onSubmit={values => onSubmit(values, 'pricesFixedForm')}
            setSubmitButton={setSubmitButton}
            isUpdate={isUpdate}
          />
        )}
        {selectedTabIndex === DAILY_PRICES.secondSection && (
          <PricesDaily
            onSubmit={values => onSubmit(values, 'pricesDailyForm')}
            setSubmitButton={setSubmitButton}
            isUpdate={isUpdate}
          />
        )}
        {selectedTabIndex === DAILY_PRICES.thirdSection && (
          <PricesEqual
            onSubmit={values => onSubmit(values, 'pricesEqualForm')}
            setSubmitButton={setSubmitButton}
            isUpdate={isUpdate}
          />
        )}
      </div>
    );
  }

  if (scheduleTabIndex === SCHEDULE_SECTION.dateTime) {
    return (
      <div className={classes.wrapper}>
        {selectedTabIndex === DAILY_PRICES.firstSection && (
          <DailyPricesFixed
            onSubmit={values => onSubmit(values, 'pricesFixedForm')}
            setSubmitButton={setSubmitButton}
            isUpdate={isUpdate}
          />
        )}
        {selectedTabIndex === DAILY_PRICES.secondSection && (
          <PricesDailySchedule
            onSubmit={values => onSubmit(values, 'pricesDailyScheduleForm')}
            setSubmitButton={setSubmitButton}
            isUpdate={isUpdate}
          />
        )}
        {selectedTabIndex === DAILY_PRICES.thirdSection && (
          <PricesEqual
            onSubmit={values => onSubmit(values, 'pricesEqualForm')}
            setSubmitButton={setSubmitButton}
            isUpdate={isUpdate}
          />
        )}
      </div>
    );
  }

  return (
    <div>
      {selectedTabIndex === DAILY_PRICES.firstSection && (
        <div className={classes.passFixedPrices}>
          <PricesFixed
            onSubmit={values => onSubmit(values, 'pricesFixedForm')}
            setSubmitButton={setSubmitButton}
            isUpdate={isUpdate}
          />
        </div>
      )}
      {selectedTabIndex === DAILY_PRICES.secondSection && (
        <div className={classes.passPrices}>
          <Typography variant="h1" className={classes.title}>
            {t('Prices')}
          </Typography>
          <PricesEqual
            onSubmit={values => onSubmit(values, 'pricesEqualForm')}
            setSubmitButton={setSubmitButton}
            isUpdate={isUpdate}
          />
        </div>
      )}
    </div>
  );
};

export default PricesCreate;
